module.exports = __webpack_public_path__ + "233c09f3ab3317c292039ea9f5e0ecae.svg";